module.exports = __webpack_public_path__ + "static/img/cooperation_1.44c5af9.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/ad/cooperation_1.png
// module id = ahjF
// module chunks = 1